<template>
  <FinanceLanding v-if="isFinance" />
  <HomeView v-else />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import FinanceLanding from './FinanceLanding.vue'
import HomeView from './HomeView.vue'

const isFinance = computed(() => {
  if (typeof window === 'undefined') return false
  return window.location.hostname === 'finance.artrofimov.xyz'
})
</script>
